<template>
  <div
    :class="{
      'logo w-[170px] shrink-0 md:w-[150px] lg:h-[47px] lg:w-[216px]': true,
    }"
  >
    <div
      :class="{
        'mr-0 md:mr-4 lg:mr-10': true,
      }"
    >
      <GeneralLink
        _type="generalLink"
        :link="logoLink"
        text=""
        data-component-name="logo-home"
        aria-label="Home"
      >
        <PtcPicture
          v-if="logoDarkText && logoDarkText.asset && logoLightText && logoLightText.asset"
          provider="sanity"
          :src="light ? logoLightText.asset._ref : logoDarkText.asset._ref"
          alt="Logo"
          :loading="'eager'"
          :preload="true"
          :img-attrs="{
            class: { ' mx-auto w-full xl:h-[43px]': true },
          }"
        />
      </GeneralLink>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { Header } from '~/sanity/types';
import GeneralLink from './GeneralLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';

interface Props extends Header {
  light?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss">
.logo .internal-link {
  display: inline !important;
}
</style>
